var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex flex-column overflow-hidden h-100 w-100" },
    [
      _c(
        "div",
        { staticClass: "tools p-1" },
        [
          _c(
            "b-btn",
            {
              directives: [
                {
                  name: "b-popover",
                  rawName: "v-b-popover.hover.bottomleft",
                  value: "Обновить",
                  expression: "'Обновить'",
                  modifiers: { hover: true, bottomleft: true }
                }
              ],
              attrs: { variant: "outline-secondary" },
              on: {
                click: function($event) {
                  return _vm.fetchAnalytic()
                }
              }
            },
            [
              _c("b-icon", {
                attrs: { icon: "arrow-clockwise", animation: _vm.busyAnalytic }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-dd",
            {
              directives: [
                {
                  name: "b-popover",
                  rawName: "v-b-popover.hover.bottomleft",
                  value: "Фильтровать по залам",
                  expression: "'Фильтровать по залам'",
                  modifiers: { hover: true, bottomleft: true }
                }
              ],
              staticStyle: { "max-height": "400px" },
              attrs: { text: _vm.currentCategory.title, variant: "primary" }
            },
            _vm._l(_vm.optionCategory, function(item) {
              return _c(
                "b-dd-item",
                {
                  key: item.id,
                  attrs: { active: item.id === _vm.filter.category_id },
                  on: {
                    click: function($event) {
                      return _vm.selectCategory(item)
                    }
                  }
                },
                [_vm._v("\n        " + _vm._s(item.title) + "\n      ")]
              )
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "b-dd",
            {
              directives: [
                {
                  name: "b-popover",
                  rawName: "v-b-popover.hover.bottomleft",
                  value: "Фильтровать по стендам",
                  expression: "'Фильтровать по стендам'",
                  modifiers: { hover: true, bottomleft: true }
                }
              ],
              staticStyle: { "max-height": "400px" },
              attrs: {
                text: _vm.currentCompany.title || _vm.filter.companyItem.title,
                variant: "success"
              }
            },
            [
              _c(
                "b-dd-form",
                { attrs: { "form-class": "px-2 pt-0" } },
                [
                  _c("b-form-input", {
                    attrs: {
                      placeholder: "Вводите для поиска",
                      type: "search"
                    },
                    model: {
                      value: _vm.filter.company_title,
                      callback: function($$v) {
                        _vm.$set(_vm.filter, "company_title", $$v)
                      },
                      expression: "filter.company_title"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm._l(_vm.optionCompany, function(item) {
                return _c(
                  "b-dd-item",
                  {
                    key: item.id,
                    attrs: { active: item.id === _vm.filter.company_id },
                    on: {
                      click: function($event) {
                        return _vm.selectCompany(item)
                      }
                    }
                  },
                  [_vm._v("\n        " + _vm._s(item.title) + "\n      ")]
                )
              })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "b-dd",
            {
              directives: [
                {
                  name: "b-popover",
                  rawName: "v-b-popover.hover.bottomleft",
                  value: "Фильтровать по дате",
                  expression: "'Фильтровать по дате'",
                  modifiers: { hover: true, bottomleft: true }
                }
              ],
              staticStyle: { "max-height": "400px" },
              attrs: {
                text: _vm.titleFilterAnalyticDate,
                variant: "outline-secondary",
                "menu-class": "calendar-calendar"
              }
            },
            [
              _c("b-dd-form", { attrs: { "form-class": "px-2 pt-0" } }, [
                _c(
                  "div",
                  { staticClass: "d-flex" },
                  [
                    _c("b-calendar", {
                      staticClass: "px-1",
                      attrs: {
                        locale: "ru",
                        "selected-variant": "success",
                        "today-variant": "info",
                        "nav-button-variant": "primary",
                        "value-as-date": "",
                        "start-weekday": "1",
                        max: _vm.maxAnalyticDateStart,
                        min: new Date(Date.UTC(2021, 1, 1))
                      },
                      model: {
                        value: _vm.filter.analytic_date.start,
                        callback: function($$v) {
                          _vm.$set(_vm.filter.analytic_date, "start", $$v)
                        },
                        expression: "filter.analytic_date.start"
                      }
                    }),
                    _vm._v(" "),
                    _c("b-calendar", {
                      staticClass: "px-1",
                      attrs: {
                        locale: "ru",
                        "selected-variant": "success",
                        "today-variant": "info",
                        "nav-button-variant": "primary",
                        "value-as-date": "",
                        "start-weekday": "1",
                        min: _vm.minAnalyticDateEnd,
                        max: new Date()
                      },
                      model: {
                        value: _vm.filter.analytic_date.end,
                        callback: function($$v) {
                          _vm.$set(_vm.filter.analytic_date, "end", $$v)
                        },
                        expression: "filter.analytic_date.end"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("b-dd-item", [
                _c(
                  "div",
                  { staticClass: "d-flex justify-content-center" },
                  [
                    _c(
                      "b-btn",
                      {
                        staticClass: "mx-1 px-3",
                        attrs: { variant: "danger" },
                        on: {
                          click: function($event) {
                            return _vm.clearFilterAnalyticDate()
                          }
                        }
                      },
                      [_vm._v("Сбросить")]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-btn",
                      { staticClass: "mx-1", attrs: { variant: "success" } },
                      [_vm._v("Применить")]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "w-100 h-100" },
        [
          _c("v-chart", {
            ref: "bar",
            staticClass: "w-100 h-100",
            attrs: {
              option: _vm.getDataset,
              "init-options": _vm.initOptions,
              theme: "ovilia-green",
              autoresize: ""
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }